/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const analyticFrozenFundsService = {
  getList: (params: any) => request.get('/analytic/frozen-funds', { params })
};

export default analyticFrozenFundsService;
